import { action, computed, makeObservable, observable } from 'mobx'
import { checkIsMobile, getContentfulImageURL } from '../lib/helpers'

class UIStore {
  constructor(rootStore) {
    this.rootStore = rootStore

    makeObservable(this)
  }

  @observable windowWidth =
    typeof window !== `undefined` ? window.innerWidth : undefined
  @observable windowHeight =
    typeof window !== `undefined` ? window.innerHeight : undefined
  @observable isMobile = typeof window !== `undefined` ? checkIsMobile() : false

  @observable scrollPosition = 0
  lastScrollPosition = 0
  scrolledDistanceSinceCollapse = 0;
  @observable scrollPositionTotal = 0
  @observable pageHeight = 0

  @observable index__showIntroAnimation = true
  @observable index__introAnimateTransform = 0
  @observable index__initSecondStageIntro = false
  @observable index__initThirdStageIntro = false
  @observable index__initFourthStageIntro = false;

  @observable indexv2__timerCarouselActiveSlideIndex = 0;
  @observable indexv2__timerCarouselTimeIdx = 0;
  @observable indexv2__timerCarouselPct = 0;

  @observable navModule__collapsed = false;


  @observable index__introImages = {
    bloom: [],
    full: null,
    flipping: [],
    flippingMobile: [],
    mask: null,
  }

  @observable index__activeIntroFlipState = 0
  index__introFlipStates = [
    {
      color: '#ffe01b',
    },
    {
      color: '#dbff00',
    },
    {
      color: '#ff84e0',
    },
    {
      color: '#79e986',
    },
    {
      color: '#ff7640',
    },
  ]

  articleColors = {}
  @observable articleColorsSet = false

  @observable transitionColor = '#fff'

  @observable map__t = 0
  @observable map__offset = { x: 0, y: 0 }
  @observable map__cursorPos = { x: 0, y: 0 }
  @observable map__activeArticle = null
  @observable map__activeListArticle = null

  @observable map__activeArticleImage = null
  @observable map__activeFilter = undefined
  @observable map__activeFilterMobile = 'Business'
  @observable map__backgroundImages = []
  @observable map__articleOrder = []

  @observable directory__articles = []
  @observable directory__mobileMenuOpen = false

  // @observable beyond__activeTab = null
  // @observable beyond__tabHasBeenSelected = false
  // @observable beyond__timerId = null
  // @observable beyond__sectionData = []
  // @observable beyond__takeaways = null

  @observable footer__color = 'white'
  @observable footer__textColor = '#000'
  @observable navBar__color = 'var(--color--offWhite)'
  @observable navBar__textColor = '#fff'

  @observable community__activeTab = null;
  @observable community__listData = null
  @observable community__mobileMenuOpen = false

  @observable article__primaryColor = null
  @observable article__secondaryColor = null
  @observable article__uiHoverColor = null
  @observable article__textHighlightColor = null
  @observable article__takeaways = null
  @observable article__resources = null
  @observable article__hasVideo = false
  @observable article__sectionMarkers = []

  @observable article__relatedArticles = null
  @observable article__modalImages = []
  @observable article__modalActive = false
  @observable article__layoutHeights = []
  @observable article__layoutRefs = []
  @observable article__layoutLocations = []

  @observable article__totalHeight = 0
  @observable article__showNumberedSelectorLegend = false
  @observable article__numberedSelectorActiveKey = 0

  @observable article__numberedSelectorKeys = []

  @observable counter__count = 0

  @action.bound updateTransitionColor(color) {
    this.transitionColor = color
  }

  @action.bound updateArticleColors(articles) {
    const makeSlug = (article) =>
      `/bloomseason/${article.category.toLowerCase()}/${article.slug}/`
    articles.forEach((a) => {
      this.articleColors[makeSlug(a)] = a.primaryColor
    })

    this.articleColorsSet = true
  }

  @action.bound removeIntroAnimation() {
    this.index__showIntroAnimation = false
  }

  @action.bound updateIntroAnimationTransform(amt) {
    this.index__introAnimateTransform = amt
  }

  @action.bound initSecondStageIntro() {
    this.index__initSecondStageIntro = true
  }

  @action.bound initThirdStageIntro() {
    this.index__initThirdStageIntro = true
    setTimeout(this.incrementFlippingImagesIntro, 500)
  }

  @action.bound initFourthStageIntro() {
    this.index__initFourthStageIntro = true
  }

  @action.bound incrementFlippingImagesIntro() {
    // if (this.index__showIntroAnimation) {
    this.index__activeIntroFlipState++
    const time = this.index__activeIntroFlipState >= 5 ? 2500 : 500

    this.flippingImagesTimer = setTimeout(
      this.incrementFlippingImagesIntro,
      time
    )
    // }

    if (
      !this.index__initFourthStageIntro &&
      this.index__activeIntroFlipState >= 5
    ) {
      this.initFourthStageIntro()
    }
  }

  @action.bound updateMapOffset(e) {
    // return
    this.map__offsetTempX = (e.clientX / this.windowWidth) * 2.1 - 1.05
    this.map__offsetTempY = (e.clientY / this.windowHeight) * -2.6 + 1.3

    this.setMapCursorPos(e)
  }

  // requestMapTick() {
  //   if (!this.map__ticking) {
  //     requestAnimationFrame(this.setMapOffset)
  //   }

  //   this.map__ticking = true
  // }

  @action.bound initMapAnimation() {
    if (this.map__animating) return
    this.setMapOffset()
    this.map__animating = true
  }

  @action.bound setMapOffset() {
    if (this.map__activeFilter) {
      // this.map__ticking = false
      this.map__animating = false
      return
    }

    if (this.map__activeArticle) {
      this.map__AnimationFrame = requestAnimationFrame(this.setMapOffset)
      return
    }

    this.map__t += 0.005

    const diffX = this.map__offsetTempX - this.map__offset.x
    const diffY = this.map__offsetTempY - this.map__offset.y
    if (diffX && diffY) {
      this.map__offset.x += diffX / 50
      this.map__offset.y += diffY / 50
    }

    // if (Math.abs(diffX) < 0.01 && Math.abs(diffY) < 0.01) {
    // this.map__ticking = false
    // } else {
      this.map__AnimationFrame = requestAnimationFrame(this.setMapOffset)
    // }
  }

  @action.bound setMapActiveArticle(article) {
    this.map__activeArticle = article
  }
  @action.bound setMapActiveListArticle(article) {
    this.map__activeListArticle = article
  }

  @action.bound setMapActiveArticleImage(image) {
    this.map__activeArticleImage = image
  }

  @action.bound setMapCursorPos(e) {
    this.map__cursorPos.x = e.pageX
    this.map__cursorPos.y = e.pageY
  }
  @action.bound toggleMobileDirectoryMenu() {
    this.directory__mobileMenuOpen = !this.directory__mobileMenuOpen
  }

  @action.bound updateMapActiveFilter(filter) {
    this.map__activeFilter = filter
  }

  @action.bound updateMapActiveFilterMobile(filter) {
    this.map__activeFilterMobile = filter
  }

  @action.bound updateMapBackgroundImages(images) {
    this.map__backgroundImages = images
  }

  @action.bound updateIntroImages(node) {
    this.index__introImages.bloom = node.introBloomImages
    this.index__introImages.full = node.introFullImage
    this.index__introImages.mask = node.introMaskImage
    this.index__introImages.flipping = node.introFlipImages
    this.index__introImages.flippingMobile = node.introFlipImagesMobile
  }

  @action.bound preloadMapHoverImages() {
    this.directory__articles.forEach((article) => {
      const image = new Image()
      image.src = getContentfulImageURL(
        article.homeHoverImage.file.url,
        1600,
        80
      )
    })
  }

  @computed get orderedMapArticles() {
    const dir = {}
    this.directory__articles.forEach((article) => {
      dir[article.slug] = article
    })

    const ordered = this.map__articleOrder.map((article) => {
      return dir[article.slug]
    })

    return ordered
  }

  @action.bound updateMapArticleOrder(order) {
    this.map__articleOrder = order
  }

  @action.bound updateDirectoryArticles(articles) {
    this.updateArticleColors(articles)

    this.directory__articles = articles
  }

  @action.bound updateWindowHeight(height) {
    this.windowHeight = height
  }

  @action.bound updateWindowWidth(width) {
    this.windowWidth = width
  }
  @action.bound updateFooterColor(color) {
    this.footer__color = color
  }
  @action.bound updateFooterTextColor(color) {
    this.footer__textColor = color
  }
  @action.bound updateNavBarColor(color) {
    this.navBar__color = color
  }
  @action.bound updateNavBarTextColor(color) {
    this.navBar__textColor = color
  }
  @action.bound updateBeyondSectionData(data) {
    this.beyond__sectionData = data
  }
  @action.bound updateBeyondActiveTab(tab) {
    this.beyond__activeTab = tab
  }
  @action.bound updateBeyondTabHasBeenSelected(selected) {
    this.beyond__tabHasBeenSelected = selected
  }
  @action.bound updateBeyondTimerId(id) {
    this.beyond__timerId = id
  }
  @action.bound updateBeyondTakeaways(takeaways) {
    this.beyond__takeaways = takeaways
  }
  @action.bound stopBeyondTimer() {
    window.clearInterval(this.beyond__timerId)
  }
  @action.bound updateModalImages(images) {
    this.article__modalImages = images
  }
  @action.bound updateShowNumberedSelectorLegend(show) {
    this.article__showNumberedSelectorLegend = show
  }
  @action.bound updateNumberedSelectorLegend(keys) {
    this.article__numberedSelectorKeys = keys
  }
  @action.bound updateNumberedSelectorActiveKey(key) {
    this.article__numberedSelectorActiveKey = key
  }
  @action.bound updateModalActive(isActive) {
    this.article__modalActive = isActive
  }
  @action.bound updateCommunityActiveTab(tab) {
    this.community__activeTab = tab
  }
  @action.bound updateCommunityListData(data) {
    this.community__listData = data
  }
  @action.bound updateCommunityMobileMenuOpen(data) {
    this.community__mobileMenuOpen = data
  }
  @action.bound updateArticlePrimaryColor(color) {
    this.article__primaryColor = color
  }

  @action.bound updateArticleUIHoverColor(color) {
    this.article__uiHoverColor = color
  }

  @action.bound updateArticleSectionMarkers(sectionMarkers) {
    this.article__sectionMarkers = sectionMarkers
  }

  @action.bound updateArticleSecondaryColor(color) {
    this.article__secondaryColor = color
  }
  @action.bound updateArticleHasVideo(hasVideo) {
    this.article__hasVideo = hasVideo
  }
  @action.bound updateArticleTextHighlightColor(color) {
    this.article__textHighlightColor = color
  }
  @action.bound updateArticleRelatedArticles(related) {
    this.article__relatedArticles = related
  }
  @action.bound updateArticleTakeaways(takeaways) {
    this.article__takeaways = takeaways
  }
  @action.bound updateArticleResources(resources) {
    this.article__resources = resources
  }
  @action.bound resetArticleLayoutHeights() {
    this.article__layoutHeights = []
    this.article__layoutLocations = []
  }
  @action.bound pushArticleLayoutHeight(height) {
    this.article__layoutHeights.push(height)
    this.updateArticleTotalHeight()
  }

  @action.bound pushArticleLayoutLocations(loc) {
    this.article__layoutLocations.push(loc)
  }

  @action.bound pushArticleLayoutRef(ref) {
    this.article__layoutRefs.push(ref)
  }
  @action.bound updateArticleTotalHeight() {
    this.article__totalHeight = this.article__layoutHeights.reduce(
      (a, b) => a + b
    )
  }

  @computed get windowScrollPositionPixels() {
    return this.scrollPosition * this.pageHeight
  }

  @computed get parallaxScrollPosition() {
    if (this.isMobile) return 0
    return 0
    return this.scrollPosition * this.pageHeight
  }

  @action.bound getPageHeight() {
    var height = Math.max(
      document.body.scrollHeight,
      document.body.offsetHeight
    )

    this.pageHeight = height
  }

  @action.bound requestScrollPositionUpdae() {}

  @action.bound updateScrollPosition(pos) {
    // this.scrollPosition = pos;
    this.requestScrollTick()
  }

  requestScrollTick() {
    if (!this.scroll__ticking) {
      requestAnimationFrame(this.setScrollPosition)
    }
    this.scroll__ticking = true
  }

  @action.bound setScrollPosition() {
    const winScroll = window.scrollY

    const height = document.body.clientHeight - this.windowHeight

    const scrolled = winScroll / height;
    const scrollTrigger = this.isMobile ? 30 : 80;
    this.lastScrollPosition = this.scrollPosition

    this.scrollPosition = scrolled
    this.scroll__ticking = false



    if (!this.navModule__collapsed && !this.rootStore.articleQueryStore.isSearching) {
      if (this.lastScrollPosition < this.scrollPosition) {
        this.scrolledDistanceSinceCollapse += 1;
      }

      if (this.scrolledDistanceSinceCollapse > scrollTrigger) {
        this.collapseNavModule()
      }
    }

  }
  

  // @computed get hideMobileNavBar() {
  //   const offset = this.windowScrollPositionPixels
  //   const pastNavBar = offset > 8 * 12
  //   const atEnd = offset < this.pageHeight - 1000
  //   const scrolledUp = this.scrollPosition < this.lastScrollPosition

  //   if (pastNavBar && atEnd && !scrolledUp) {
  //     return true
  //   }

  //   return false
  // }

 

  @action.bound scrollTo(top) {
    window.scrollTo({
      top,
      behavior: 'smooth',
    })
  }


  @action.bound scrollToRef(index) {
    const top = this.article__layoutRefs[index].current.offsetTop - 79

    window.scrollTo({
      top,
      behavior: 'smooth',
    })
  }

  @action.bound incrementCounter() {
    this.counter__count++
  }

  @action.bound decrementCounter() {
    this.counter__count--
  }

  @action.bound clearRouteVaribles() {
    this.scrollPosition = 0

    this.map__activeArticle = null
    this.map__activeFilter = null
    this.map__activeArticleImage = null
    this.map__activeListArticle = null
    this.map__animating = false
    if (this.map__AnimationFrame) {
      cancelAnimationFrame(this.map__AnimationFrame);
    }

    this.directory__mobileMenuOpen = false;
    this.article__layoutHeights = []
    this.article__layoutRefs = []
    this.article__totalHeight = 0
    if (this.flippingImagesTimer) {
      clearTimeout(this.flippingImagesTimer)
    }

    this.clearBeyondLandingCycle();
    this.updateBeyondLandingActiveArticle(null);
  }

  @observable beyond__landingActiveArticle = null;
  @observable beyond__landingActiveCycleArticle = 0;
  beyond__cycleTimeout = null;
  beyond__articleTimeout = null;


  @action.bound initBeyondLandingCycle() {
    if (this.beyond__cycleTimeout) return 

    this.beyond__cycleTimeout = setInterval(this.updateBeyondLandingCycleArticle, 4000)
  }

  @action.bound clearBeyondLandingArticle() {
    this.beyond__articleTimeout = setTimeout(() => {
      this.updateBeyondLandingActiveArticle(null);
      this.initBeyondLandingCycle();
    }, 2000)
  }

  @action.bound clearBeyondLandingCycle() {
    if (this.beyond__cycleTimeout) {
      clearInterval(this.beyond__cycleTimeout);
      this.beyond__cycleTimeout = null;
    }
  }

  @action.bound updateBeyondLandingCycleArticle() {
    this.beyond__landingActiveCycleArticle++;

    if (this.beyond__landingActiveCycleArticle > 4) {
      this.beyond__landingActiveCycleArticle = 0;
    }
  }

  @action.bound updateBeyondLandingActiveArticle(article) {
    if (this.beyond__articleTimeout) {
      clearTimeout(this.beyond__articleTimeout);
      this.beyond__articleTimeout = null;
    }

    this.beyond__landingActiveArticle = article
    
  }

  @action.bound updateBeyondArticleColors() {
    this.articleColors['/bloomseason/beyond/'] = 'black';
    this.articleColors['/beyond/'] = 'black';

    this.articleColors['/bloomseason/beyond/food-beverage/'] = '#efaed5';
    this.articleColors['/beyond/food-beverage/'] = '#efaed5';

    this.articleColors['/bloomseason/beyond/college-athletics/'] = '#f5bc94';
    this.articleColors['/beyond/college-athletics/'] = '#f5bc94';

    this.articleColors['/bloomseason/beyond/sustainability/'] = '#e4fc52';
    this.articleColors['/beyond/sustainability/'] = '#e4fc52';

    this.articleColors['/bloomseason/beyond/beauty/'] = '#f19347';
    this.articleColors['/beyond/beauty/'] = '#f19347';

    this.articleColors['/bloomseason/beyond/media-entertainment/'] = '#a3fcef';
    this.articleColors['/beyond/media-entertainment/'] = '#a3fcef';
  }


  @action.bound updateCarouselTimer() {
    this.indexv2__timerCarouselTimeIdx += 1;
    this.indexv2__timerCarouselPct = (this.indexv2__timerCarouselTimeIdx / (60 * 8)) * 100;
    // this.indexv2__timerCarouselPct = (this.indexv2__timerCarouselTimeIdx / (60 * 3)) * 100;

    if(this.indexv2__timerCarouselPct >= 100) {
      this.incrementCarouselSlide()
    }

    this.carouselAnimationFrame = requestAnimationFrame(this.updateCarouselTimer);
  }

  @action.bound incrementCarouselSlide() {
    this.indexv2__timerCarouselTimeIdx = 0;
    this.indexv2__timerCarouselPct = 0;
    this.indexv2__timerCarouselActiveSlideIndex += 1;
    if (this.indexv2__timerCarouselActiveSlideIndex > 2) {
      this.indexv2__timerCarouselActiveSlideIndex = 0;
    }
  }

  @action.bound decrementCarouselSlide() {
    let goToPrev = this.indexv2__timerCarouselPct < 45;

    this.indexv2__timerCarouselTimeIdx = 0;
    this.indexv2__timerCarouselPct = 0;
     
    if (goToPrev) {
      this.indexv2__timerCarouselActiveSlideIndex -= 1;
      if (this.indexv2__timerCarouselActiveSlideIndex < 0) {
        this.indexv2__timerCarouselActiveSlideIndex = 2;
      }
    }
  }




  @action.bound stopCarouselTimer() {
    if (this.carouselAnimationFrame) {
      cancelAnimationFrame(this.carouselAnimationFrame);
    }
  }


  @action.bound collapseNavModule() {
    this.navModule__collapsed = true;
  }

  @action.bound openNavModule() {
    this.navModule__collapsed = false;
    this.scrolledDistanceSinceCollapse = 0;
  }






}

export default UIStore
